import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Note } from './note.dto';
import { Query, QueryService, SearchResult } from '@damofire/data-commons';

@Injectable()
export abstract class ObservableNoteService {
  abstract observeIssueNotes(divisionId: string, issueId: string): Observable<Note[]>;
  abstract observeNotes(divisionId: string, inspectionId: string, assetId?: string): Observable<Note[]>;
  abstract observeDivisionNotes(divisionId: string): Observable<Note[]>;

  search(divisionId: string, inspectionId: string, q: Query): Observable<SearchResult<Note>> {
    return this.observeNotes(divisionId, inspectionId).pipe(
      map((notes) => {
        return QueryService.applyQuery<Note>(notes, q, ['issue.descriptionEn', 'issue.descriptionFr', 'issue.warehouseIssueId', 'asset.description', 'text']);
      }),
    );
  }
}
